__turbopack_context__.v({
  "applicationLoader": "HomeConnectModalFormNew-module-scss-module__FolBOq__applicationLoader",
  "authorization": "HomeConnectModalFormNew-module-scss-module__FolBOq__authorization",
  "bold": "HomeConnectModalFormNew-module-scss-module__FolBOq__bold",
  "card": "HomeConnectModalFormNew-module-scss-module__FolBOq__card",
  "cards": "HomeConnectModalFormNew-module-scss-module__FolBOq__cards",
  "commonMargins": "HomeConnectModalFormNew-module-scss-module__FolBOq__commonMargins",
  "divider": "HomeConnectModalFormNew-module-scss-module__FolBOq__divider",
  "dropdown": "HomeConnectModalFormNew-module-scss-module__FolBOq__dropdown",
  "emailContainer": "HomeConnectModalFormNew-module-scss-module__FolBOq__emailContainer",
  "error": "HomeConnectModalFormNew-module-scss-module__FolBOq__error",
  "errorMessage": "HomeConnectModalFormNew-module-scss-module__FolBOq__errorMessage",
  "filled": "HomeConnectModalFormNew-module-scss-module__FolBOq__filled",
  "filled_seat_container": "HomeConnectModalFormNew-module-scss-module__FolBOq__filled_seat_container",
  "filled_seats": "HomeConnectModalFormNew-module-scss-module__FolBOq__filled_seats",
  "formHeading": "HomeConnectModalFormNew-module-scss-module__FolBOq__formHeading",
  "half": "HomeConnectModalFormNew-module-scss-module__FolBOq__half",
  "inputWrapper": "HomeConnectModalFormNew-module-scss-module__FolBOq__inputWrapper",
  "programListForm": "HomeConnectModalFormNew-module-scss-module__FolBOq__programListForm",
  "progress-bar-slide": "HomeConnectModalFormNew-module-scss-module__FolBOq__progress-bar-slide",
  "root": "HomeConnectModalFormNew-module-scss-module__FolBOq__root",
  "stars": "HomeConnectModalFormNew-module-scss-module__FolBOq__stars",
  "termserror": "HomeConnectModalFormNew-module-scss-module__FolBOq__termserror",
  "text": "HomeConnectModalFormNew-module-scss-module__FolBOq__text",
  "text_field": "HomeConnectModalFormNew-module-scss-module__FolBOq__text_field",
  "w25": "HomeConnectModalFormNew-module-scss-module__FolBOq__w25",
  "w75": "HomeConnectModalFormNew-module-scss-module__FolBOq__w75",
});
